import { useEffect } from "react";
import { useDispatch } from "react-redux";
import GlobalLogoutClient from "../services/forced-logout-services";
import secureLocalStorage from "react-secure-storage";
import { store } from "../redux/store";
import { resetAuctionData, stopSocketConnection } from "../redux/auctions/auctions.actions";
import { resetCommonReducer } from "../redux/common/common.actions";
import { resetUserState } from "../redux/user/user.actions";

export default function useTabGuard() {
  const dispatch = useDispatch();

  useEffect(() => {
    const navEntries = performance.getEntriesByType(
      "navigation"
    ) as PerformanceNavigationTiming[];

    const navType = navEntries[0]?.type;

    const existingTabId = sessionStorage.getItem("tabId");

    if (!existingTabId) {
      sessionStorage.setItem("tabId", Date.now().toString());
    } else {
      if (navType !== "reload") {
        sessionStorage.clear();
        store.getState().auction?.socket?.connected && store.dispatch(stopSocketConnection());
        store.dispatch(resetAuctionData());
        store.dispatch(resetCommonReducer());
        store.dispatch(resetUserState());
        secureLocalStorage.clear();
        window.location.replace("/");
      }
    }
  }, [dispatch]);
}